module.exports = __webpack_public_path__ + "img/thumbnail_EurasianLynx_m_albino.9ff58e29.png";